import { repository } from '../../data'
import type { GroupView, View } from './derive'
import { useWrite } from './parts'

/** What to do with the ticked machines: a new group, into a group, out of the one being looked at. */
export function SelectionBar({
  view,
  selected,
  filteredGroup,
  onNewGroup,
  onDone,
}: {
  view: View
  selected: ReadonlySet<string>
  filteredGroup: GroupView | undefined
  onNewGroup: () => void
  onDone: () => void
}): JSX.Element {
  const ids = [...selected]
  const n = `${ids.length} ${ids.length === 1 ? 'machine' : 'machines'}`
  const into = useWrite(
    (groupId: string) => repository.setGroupMachines(groupId, ids, true).then((r) => (onDone(), r)),
    (groupId) => `Added ${n} to ${view.group(groupId)?.name}`,
  )
  const outOf = useWrite(
    () => repository.setGroupMachines(filteredGroup?.id as string, ids, false).then((r) => (onDone(), r)),
    () => `Took ${n} out of ${filteredGroup?.name}`,
  )
  const custom = view.groups.filter((g) => g.kind === 'custom')
  return (
    <div className="cx-selection" role="region" aria-label="Selected machines">
      <strong>{n} selected</strong>
      <button className="primary" onClick={onNewGroup}>
        New group from these
      </button>
      {custom.length ? (
        <select value="" aria-label="Add to a group" disabled={into.pending} onChange={(e) => e.currentTarget.value && into.run(e.currentTarget.value)}>
          <option value="">Add to a group…</option>
          {custom.map((g) => (
            <option key={g.id} value={g.id}>{g.name}</option>
          ))}
        </select>
      ) : null}
      {filteredGroup && filteredGroup.kind === 'custom' ? (
        <button className="danger" disabled={outOf.pending} onClick={() => outOf.run()}>
          Take out of {filteredGroup.name}
        </button>
      ) : null}
      <button onClick={onDone}>Clear</button>
    </div>
  )
}
